import { type OptionType } from "@vega-core/models/options";
import { m } from "@vega-core/paraglide/messages";
import { useTableFilters } from "@vega-modules/components/Table/TableFilters/hooks/useTableFilters";
import {
  FilterType,
  TableFilterId,
  type TableFiltersConfig,
} from "@vega-modules/components/Table/TableFilters/types";

export const eventNameOptions: OptionType[] = [
  {
    value: "coinvest_data_room_accessed",
    label: m.coInvestments_audit_event_DATA_ROOM_ACCESSED(),
  },
  {
    value: "coinvest_deal_rejected",
    label: m.coInvestments_audit_event_DEAL_REJECTED(),
  },
  {
    value: "coinvest_nda_dismissed",
    label: m.coInvestments_audit_event_NDA_DISMISSED(),
  },
  {
    value: "coinvest_nda_downloaded",
    label: m.coInvestments_audit_event_NDA_DOWNLOADED(),
  },
  {
    value: "coinvest_nda_opened",
    label: m.coInvestments_audit_event_NDA_OPENED(),
  },
  {
    value: "coinvest_nda_signed",
    label: m.coInvestments_audit_event_NDA_SIGNED(),
  },
  {
    value: "coinvest_nda_signed_by_gp",
    label: m.coInvestments_audit_event_NDA_SIGNED_BY_GP(),
  },
  {
    value: "coinvest_outreach_email_sent",
    label: m.coInvestments_audit_event_OUTREACH_EMAIL_SENT(),
  },
];

export const useAuditFilters = () => {
  const filtersConfig = {
    filters: [
      {
        id: "eventNames",
        type: FilterType.Multiselect,
        label: m.coInvestments_audit_filterByEvent(),
        props: {
          placeholder: m.coInvestments_audit_filterByEvent(),
          options: eventNameOptions,
          contentWrapperClassName: "min-w-80",
        },
      },
    ],
    showResetButton: true,
  } as const satisfies TableFiltersConfig;

  const { filterState, RenderFilters, hasActiveFilters } = useTableFilters({
    id: TableFilterId.CoInvestmentsAudit,
    config: filtersConfig,
    isLoading: false,
    syncWithURL: true,
    showSavedFilters: false,
    persistInSession: false,
  });

  const selectedEventNames = (
    filterState.eventNames as OptionType[] | undefined
  )
    ?.map((option) => option.value)
    .filter(Boolean);

  return {
    filterState,
    RenderFilters,
    hasActiveFilters,
    selectedEventNames:
      selectedEventNames && selectedEventNames.length > 0
        ? selectedEventNames
        : undefined,
  };
};
